import Intro from '../components/Intro/Intro';

function IntroScreen() {
  return <Intro />;
}

export default IntroScreen;
